import { useEffect, useState } from 'react';
import { Transaction, getTransactions } from 'src/api/pmApi';
import { apiErrorHandling } from '../api/apierrorhandling';
import { generalStore } from '../stores/GeneralStore';

export const useTransactions = (
  filters: {
    status: 'reserved' | 'success';
    page?: number;
    rowsPerPage?: number;
    sort?: 'newest' | 'oldest';
    userId?: string;
    dateMin?: string;
    dateMax?: string;
  },
  reload: boolean,
) => {
  const [transactions, setTransactions] = useState<{ data: Transaction[]; count: number }>({ data: [], count: 0 });
  const load = async () => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getTransactions(filters)).data;
      setTransactions(response.data);
    } catch (error: any) {
      apiErrorHandling(error, 'Error Getting Reserved Transactions');
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [filters.page, filters.rowsPerPage, filters.sort, filters.userId, filters.dateMax, filters.dateMin, reload]);

  return transactions || [];
};
